import type { QueryClient } from '@tanstack/react-query';
import { authClient } from './auth-client';

export const SESSION_QUERY_KEY = ['session'] as const;

export function fetchSession(queryClient: QueryClient) {
  return queryClient.fetchQuery({
    queryKey: SESSION_QUERY_KEY,
    queryFn: () => authClient.getSession(),
    staleTime: 0,
  });
}

export async function refreshSessionAfterAuth(queryClient: QueryClient) {
  queryClient.removeQueries({ queryKey: SESSION_QUERY_KEY });
  return fetchSession(queryClient);
}

export function hasActiveSession(
  session: Awaited<ReturnType<typeof authClient.getSession>> | undefined,
) {
  return Boolean(session?.data?.session);
}
